import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Benfitsbuild = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 100%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1.05, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='benifitsprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="beniftschlprnt">
                        <h2>Key Benefits</h2>
                        <div className="benifitscardsprnt">
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[0] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Buildimgs\benifitcardoneimg.png" alt="" />
                                </div>
                                <img className='img-fluid' src="\assets\Buildimgs\benifitcardoneimg5.svg" alt="" />
                                <h3>Monetization Made Easy</h3>
                                <p>Charge for memberships or exclusive content.</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[1] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Buildimgs\buldgrou[card2img.png" alt="" />
                                </div>
                                <img className='img-fluid' src="\assets\Buildimgs\benifitcardoneimg6.svg" alt="" />
                                <h3>Private Participation</h3>
                                <p>Followers can engage without exposing their identities.</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[2] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg3.png" alt="" />
                                </div>
                                <img className='img-fluid' src="\assets\Buildimgs\benifitcardoneimg8.svg" alt="" />
                                <h3>Secure Community Management</h3>
                                <p>Full control over members, privacy, and group rules.</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[3] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Buildimgs\buldgrou[card4img.png" alt="" />
                                </div>
                                <img className='img-fluid' src="\assets\Buildimgs\benifitcardoneimg9.svg" alt="" />
                                <h3>All-in-One Solution</h3>
                                <p>Manage conversations, transactions, and content in one place.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Benfitsbuild